module.exports = __webpack_public_path__ + "static/img/head.a484d33c.png";